
// Login Page
export const LOGIN = "Login";
export const HOME_PAGE = "Home";
export const INVENTORY_PAGE = "Inventory";
export const ORDERS_PAGE = "Orders";
export const PROFILE_PAGE = "Profile";
export const NOTIFICATIONS_PAGE = "Notification";
export const LOGOUT_PAGE = "Logout";
export const REQUEST_OTP = "REQUEST OTP";
export const INVALID_MOBILE_NUMBER = "Invalid mobile number. Enter a valid indian number";
export const LOGGED_IN_SUCESSFULLY = "Logged in sucessfully";
export const ENTER_MOBILE_NUMBER = "Enter mobile number";
export const ENTER_OTP = "Enter OTP";
export const REQUEST_NEW_OTP = "Request new OTP";
export const USER_DOES_NOT_EXIST = "You are not registered. Do you want to sign up?";
export const INVALID_OTP = "Invalid otp. Please try again";

//internal order states
export const ORDER_STATE_ALL = "*";
export const ORDER_STATE_PLACED = "Placed";
export const ORDER_STATE_ACCEPTED = "Accepted";
export const ORDER_STATE_FULFILLED = "Fulfilled";
export const ORDER_STATE_DELIVERED = "Delivered";
export const ORDER_STATE_CANCELLED = "Rejected";
export const ORDER_STATE_RTO_INITIATED = "RTO Initiated";
export const ORDER_STATE_RTO_DELIVERED = "RTO Delivered";
export const ORDER_STATE_AGENT_ASSIGNED = "Agent Assigned";
export const ORDER_STATE_PICKED_UP = "Picked Up";
export const ORDER_STATE_OUT_FOR_DELIVERY = "Out for Delivery";

//Display order states
export const ALL = "All";
export const PLACED = "Placed";
export const ACCEPTED = "Accepted";
export const FULFILLED = "Packed";
export const DELIVERED = "Delivered";
export const REJECTED = "Rejected";
export const RTO_INITIATED = "RTO Initiated";
export const RTO_DELIVERED = "RTO Delivered";
export const AGENT_ASSIGNED = "Agent Assigned";
export const OUT_FOR_DELIVERY = "Out for delivery";
export const PICKED_UP = "Picked Up";

// order mapping
export const ORDER_STATE_MAPPING = [
    {
        "internalOrderStateName": ORDER_STATE_ALL,
        "displayName": ALL
    },
    {
        "internalOrderStateName": ORDER_STATE_PLACED,
        "displayName": PLACED
    },
    {
        "internalOrderStateName": ORDER_STATE_ACCEPTED,
        "displayName": ACCEPTED
    },
    {
        "internalOrderStateName": ORDER_STATE_FULFILLED,
        "displayName": FULFILLED
    },
    {
        "internalOrderStateName": ORDER_STATE_AGENT_ASSIGNED,
        "displayName": AGENT_ASSIGNED
    },
    {
        "internalOrderStateName": ORDER_STATE_PICKED_UP,
        "displayName": PICKED_UP
    },
    {
        "internalOrderStateName": ORDER_STATE_OUT_FOR_DELIVERY,
        "displayName": OUT_FOR_DELIVERY
    },
    {
        "internalOrderStateName": ORDER_STATE_DELIVERED,
        "displayName": DELIVERED
    },
    {
        "internalOrderStateName": ORDER_STATE_CANCELLED,
        "displayName": REJECTED
    },
    {
        "internalOrderStateName": ORDER_STATE_RTO_INITIATED,
        "displayName": RTO_INITIATED
    },
    {
        "internalOrderStateName": ORDER_STATE_RTO_DELIVERED,
        "displayName": RTO_DELIVERED
    },
   
]
export const NO_IMAGE = "No image";

//inventory page
export const INVENTORY =" My Inventory";
export const SEARCH_INVENTORY = "Search Products";
export const SOMETHING_WENT_WRONG = "Something went wrong. Please try again!";
export const QUANTITY_UPDATED_SUCCESSFULLY = "Quantity updated successfully";
export const PRICE_UPDATED_SUCCESSFULLY = "Price updated successfully";
export const PRICE_CANNOT_BE_LESS_THAN_ZERO = "Price cannot be less than 0";
export const PRICE_CANNOT_BE_MORE_THAN_MRP = "Price cannot be more than mrp";
export const QUANTITY_CANNOT_BE_LESS_THAN_ZERO = "Quantity cannot be less than 0";

//order page
export const ORDER_DETAILS = "Order Details";
export const REJECT = "Reject";
export const ACCEPT ="Accept";
export const MARK_AS_PACKED ="Mark as Packed";
export const DATE_FORMAT = "YYYY-MM-DD";

//Order Data Table
export const ITEM_DETAILS = "Item Details";
export const ID = "Id";
export const IMAGE = "Image";
export const PRODUCT = "Product";
export const QUANTITY = "Qty.";
export const AVAILABLE_QTY = "Available Qty.";
export const PRICE = "Price";
export const AMOUNT = "Amount";

//Return Details card
export const RETURN_DETAILS = "Return Details";
export const RETURN_ID = "Return Id";
export const ITEM_ID = "Item Id";
export const REASON = "Reason";
export const ACTIONS = "Actions";

export const daysOfWeek = [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const WANT_TO_REJECT = "Are you sure you want to reject?";
export const SUBMIT = "Submit";
export const CLOSE = "Close";
export const NO_ACCOUNT_MESSAGE = "Don't have an account?";
export const SIGN_UP = "Sign Up";
export const ALREADY_HAVE_ACCOUNT_MESSAGE = "Already have an account? ";
export const JOIN_US_TODAY = "Join Us Today!";
export const LOGIN_HERE = "Login here";
export const BACK = "Back";
export const USER_ALREADY_EXIST = 'User already exists';
export const USER_EXIST_ALERT = 'user already exists with this number. Would you like to log in?';